import templateUrl from './list-dropdown.html';

export const listDropdownComponent = {
	templateUrl,

	bindings: {
		list: '<',
		labelText: '@',
		selectedId: '<',
		defaultOption: '@',
		multipleSelected: '<',
		key: '@',
		onChange: '&'
	},

	controller: class ListDropdownComponent {
		constructor($parse) {
			'ngInject';

			this.$parse = $parse;
		}

		$onInit() {
			// this.selectedId = this.selectedId ? this.selectedId : this.defaultOption ? this.defaultOption : this.list[0].id;
			this.selectedItems = [];
			this.settings = { 
				checkBoxes: true,
				styleActive: true,
				scrollableHeight: 300,
				scrollable: true
			};
			this.defaultText = {
				buttonDefaultText: this.defaultOption,
				checkAll: this.defaultOption,
				uncheckAll: `Clear Selections`,
				dynamicButtonTextSuffix: `Selected`
			};
			this.multiuserevents = {
				onSelectionChanged: () => {
					let selectedItems = this.selectedItems.reduce((ids, value) => {
						ids = ids.concat(value.id);
						return ids;
					}, []);
					this.onChange({$event : selectedItems});
				}
			};
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/common/components/list-dropdown/list-dropdown.component.js